import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function PainSection() {
  const thoughts = ['¿Y si no entiendo?', '¿Y si lo hago mal?', '¿Y si me trabo y nadie me ayuda?', '¿Y si empiezo y no lo termino, otra vez?'];
  const cycleSteps = ['Miedo', 'Evitación', 'Alivio corto', 'Culpa', 'Más miedo'];
  return <section className="py-24 px-4 bg-dark-900 relative" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-129">
          Si te pasa esto...
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-130">
          {thoughts.map((thought, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-800 p-6 rounded-lg border-l-4 border-amber-700/50 hover:border-amber-500 transition-colors" data-id="element-131">
              <p className="text-lg text-gray-300 italic" data-id="element-132">"{thought}"</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-133">
          <p className="text-xl text-gray-400 mb-4" data-id="element-134">
            Y lo peor: no es solo el proyecto. Es el golpe al final del día.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-135">
            "No confío en mí."
          </p>
        </motion.div>

        {/* Cycle Visualization */}
        <div className="relative py-10" data-id="element-136">
          <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none" data-id="element-137">
            <div className="w-64 h-64 border-2 border-amber-500 rounded-full" data-id="element-138"></div>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8" data-id="element-139">
            {cycleSteps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4 + index * 0.1
          }} className="flex items-center" data-id="element-140">
                <span className={`text-lg font-bold ${index === 0 || index === 4 ? 'text-amber-500' : 'text-gray-400'}`} data-id="element-141">
                  {step}
                </span>
                {index < cycleSteps.length - 1 && <ArrowDown className="w-4 h-4 mx-2 text-gray-600 -rotate-90 md:rotate-0" data-id="element-142" />}
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}